import styled from "styled-components";

export const ModuleShell = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 16px;
  min-height: 100%;
  height: 100%;
`;

export const WizardTabsHeader = styled.div`
  padding: 8px 10px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
`;

export const WizardTabsBar = styled.div`
  display: flex;
  gap: 4px;
  padding: 4px;
  border: 1px solid #dbe4f0;
  border-radius: 12px;
  background: #f8fafc;
`;

export const WizardTab = styled.button`
  flex: 1 1 0;
  min-width: 0;
  border: 1px solid transparent;
  border-radius: 10px;
  padding: 7px 8px;
  background: transparent;
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;

  &:hover {
    background: #ffffff;
    border-color: #dbe4f0;
    color: #0f172a;
  }

  &[data-active="true"] {
    background: #ffffff;
    border-color: #dbe4f0;
    color: #0f172a;
    box-shadow: 0 10px 18px rgba(15, 23, 42, 0.06), inset 0 -2px 0 #2563eb;
  }
`;

export const Rail = styled.aside`
  border: 1px solid #dbe4f0;
  border-radius: 18px;
  background: linear-gradient(180deg, #f8fbff 0%, #f2f6fb 100%);
  padding: 16px 14px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const RailEyebrow = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

export const StepList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const StepButton = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
  border: 1px solid ${(props) => (props.$active ? "#8db4ff" : "#d1dae8")};
  background: ${(props) => (props.$active ? "#eaf2ff" : "#ffffff")};
  border-radius: 14px;
  padding: 12px 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: ${(props) =>
    props.$active ? "0 8px 22px rgba(59, 130, 246, 0.14)" : "none"};

  &:hover {
    border-color: #93c5fd;
    background: #f8fbff;
  }
`;

export const StepNumber = styled.span`
  width: 28px;
  height: 28px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 800;
  color: ${(props) => (props.$active ? "#ffffff" : "#3b82f6")};
  background: ${(props) => (props.$active ? "#2563eb" : "#dbeafe")};
  flex: 0 0 28px;
`;

export const StepContent = styled.span`
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
`;

export const StepLabel = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
`;

export const StepDescription = styled.span`
  font-size: 11px;
  line-height: 1.35;
  color: #64748b;
`;

export const MainPanel = styled.div`
  min-width: 0;
  min-height: 0;
  height: 100%;
  border: 1px solid #dbe4f0;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.06);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const PreviewPanel = styled.aside`
  min-width: 0;
  border: 1px solid #dbe4f0;
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.06);
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  position: sticky;
  top: 8px;
  align-self: start;
`;

export const ModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.46);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  z-index: 1200;
`;

export const ModalContent = styled.div`
  width: min(980px, calc(100vw - 48px));
  max-height: calc(100vh - 48px);
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.22);
  border: 1px solid #dbe4f0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
`;

export const ModalTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  color: #0f172a;
`;

export const ModalClose = styled.button`
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  padding: 8px 12px;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    background: #f8fafc;
  }
`;

export const ModalBody = styled.div`
  padding: 18px;
  overflow: auto;
  background: #f8fafc;
`;

export const ModalPreviewPanel = styled.div`
  min-width: 0;
  border: 1px solid #dbe4f0;
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.06);
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  padding: 4px 18px 4px;
  border-bottom: 1px solid #e2e8f0;
`;

export const TopBarCopy = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;

  h2 {
    margin: 0;
    font-size: 20px;
    color: #0f172a;
  }

  p {
    margin: 0;
    font-size: 12px;
    line-height: 1.45;
    color: #64748b;
  }
`;

export const ActionCluster = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

export const Body = styled.div`
  flex: 1;
  min-height: 0;
  // padding: 18px 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
`;

export const SectionCard = styled.section`
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: #ffffff;
  // padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;
export const SectionCardGeneral = styled.section`
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: #ffffff;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const SectionHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;

  h3 {
    margin: 0;
    font-size: 15px;
    color: #0f172a;
  }

  p {
    margin: 4px 0 0 0;
    font-size: 12px;
    line-height: 1.45;
    color: #64748b;
  }
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  color: #b45309;
  background: #fef3c7;
  white-space: nowrap;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 14px;
`;

export const FieldBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  grid-column: ${(props) => (props.$full ? "1 / -1" : "auto")};
`;

export const FieldLabel = styled.label`
  font-size: 12px;
  font-weight: 700;
  color: #334155;
`;

export const FieldHint = styled.span`
  font-size: 11px;
  line-height: 1.4;
  color: #64748b;
`;

export const Input = styled.input`
  width: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 12px;
  color: #0f172a;
  background: ${(props) => (props.$muted ? "#f8fafc" : "#ffffff")};
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #60a5fa;
    box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.14);
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 12px;
  color: #0f172a;
  background: #ffffff;
  box-sizing: border-box;
  min-height: ${(props) => props.$minHeight || "96px"};
  resize: vertical;

  &:focus {
    outline: none;
    border-color: #60a5fa;
    box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.14);
  }
`;

export const SelectInput = styled.select`
  width: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 12px;
  color: #0f172a;
  background: #ffffff;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #60a5fa;
    box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.14);
  }
`;

export const HintBox = styled.div`
  border: 1px dashed #bfd3f2;
  background: #f8fbff;
  color: #475569;
  border-radius: 14px;
  padding: 12px 14px;
  font-size: 12px;
  line-height: 1.5;
`;

export const FieldsLayout = styled.div`
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  gap: 14px;
`;

export const FieldsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const FieldCard = styled.button`
  border: 1px solid ${(props) => (props.$active ? "#8db4ff" : "#d6dee9")};
  background: ${(props) => (props.$active ? "#eff6ff" : "#ffffff")};
  border-radius: 14px;
  padding: 12px;
  cursor: pointer;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-shadow: ${(props) =>
    props.$active ? "0 8px 22px rgba(59, 130, 246, 0.12)" : "none"};
`;

export const FieldCardTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const FieldCardTitle = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
`;

export const FieldCardMeta = styled.span`
  font-size: 11px;
  color: #64748b;
  line-height: 1.35;
`;

export const EmptyState = styled.div`
  border: 1px dashed #cbd5e1;
  border-radius: 14px;
  padding: 16px;
  background: #f8fafc;
  color: #64748b;
  font-size: 12px;
  line-height: 1.45;
`;

export const ToggleWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const ToggleChip = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #d6dee9;
  border-radius: 999px;
  padding: 7px 12px;
  background: ${(props) => (props.$checked ? "#eff6ff" : "#ffffff")};
  color: #334155;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;

  input {
    margin: 0;
  }
`;

export const InlineSplit = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
`;

export const SourcePanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const AutoFillBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px 20px;
  align-items: center;
`;

export const CheckboxRow = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 700;
  color: ${(props) => (props.$disabled ? "#94a3b8" : "#334155")};

  input {
    margin: 0;
  }
`;

export const ResultPresetGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
`;

export const ResultPresetCard = styled.button`
  border: 1px solid ${(props) => (props.$active ? "#8db4ff" : "#d6dee9")};
  background: ${(props) => (props.$active ? "#eff6ff" : "#ffffff")};
  border-radius: 14px;
  padding: 14px;
  text-align: left;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const ResultPresetTitle = styled.span`
  font-size: 13px;
  font-weight: 800;
  color: #0f172a;
`;

export const ResultPresetText = styled.span`
  font-size: 11px;
  line-height: 1.45;
  color: #64748b;
`;

export const CodeShell = styled.div`
  border: 1px solid #20243a;
  border-radius: 16px;
  background: #111322;
  overflow: hidden;
  box-shadow: 0 16px 32px rgba(2, 6, 23, 0.18);
`;

export const CodeTopbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 7px 10px;
  background: linear-gradient(180deg, #191a2a 0%, #151625 100%);
  border-bottom: 1px solid #2b2d42;
`;

export const CodeWindow = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
`;

export const CodeDot = styled.span`
  width: 11px;
  height: 11px;
  border-radius: 999px;
  background: ${(props) => props.$color};
`;

export const CodeTab = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  position: relative;
  background: linear-gradient(180deg, #1f2233 0%, #181a28 100%);
  color: #cdd6f4;
  border: 1px solid #3a3f5a;
  border-radius: 9px;
  padding: 5px 9px;
  font-size: 10px;
  font-weight: 700;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);

  small {
    color: #89b4fa;
    font-size: 9px;
  }

  &::before {
    content: "";
    position: absolute;
    top: -1px;
    left: 9px;
    right: 9px;
    height: 2px;
    border-radius: 999px;
    background: #89b4fa;
  }
`;

export const CodeTheme = styled.span`
  color: #c4c9dd;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.02em;
  background: rgba(137, 180, 250, 0.08);
  border: 1px solid rgba(137, 180, 250, 0.16);
  border-radius: 999px;
  padding: 3px 8px;
  white-space: nowrap;
`;

export const CodeHelpers = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  background: #0d1020;
  color: #e2e8f0;
  border-bottom: 1px solid #2b2d42;
  font-size: 12px;
  font-weight: 700;
`;

export const CodeChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
`;

export const CodeChip = styled.button`
  border: none;
  border-radius: 999px;
  padding: 6px 10px;
  background: #2a2e47;
  color: #bcd2ff;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
`;

export const CodeEditorMain = styled.div`
  display: flex;
  align-items: stretch;
  min-height: 310px;
  background: #1e1e2e;
`;

export const CodeGutter = styled.div`
  width: 48px;
  flex: 0 0 48px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 14px 8px 14px 0;
  background: #181825;
  border-right: 1px solid #313244;
  color: #7f849c;
  font-size: 12px;
  line-height: 1.55;
  font-family: var(--font-mono);
  overflow: hidden;
  user-select: none;
`;

export const CodeGutterLine = styled.span`
  width: 100%;
  height: 18.6px;
  text-align: right;
`;

export const CodeTextarea = styled.textarea`
  flex: 1;
  min-height: 310px;
  border: none;
  border-radius: 0;
  padding: 14px 16px 14px 14px;
  background: #1e1e2e;
  color: #cdd6f4;
  font-size: 12px;
  line-height: 1.55;
  font-family: var(--font-mono);
  resize: vertical;
  outline: none;
  box-sizing: border-box;
`;

export const CodeFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
  padding: 8px 12px;
  background: #1f6feb;
  border-top: 1px solid #2563eb;
  color: #eff6ff;
  font-size: 10px;

  strong {
    color: #ffffff;
  }
`;

export const PreviewHeader = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: flex-start;

  h3 {
    margin: 0;
    font-size: 17px;
    color: #0f172a;
  }

  p {
    margin: 4px 0 0 0;
    font-size: 12px;
    line-height: 1.45;
    color: #64748b;
  }
`;

export const StatusPill = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  color: ${(props) => (props.$active ? "#166534" : "#991b1b")};
  background: ${(props) => (props.$active ? "#dcfce7" : "#fee2e2")};
`;

export const PreviewHero = styled.div`
  background: linear-gradient(135deg, #1d4ed8 0%, #2563eb 58%, #3b82f6 100%);
  border-radius: 18px;
  padding: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const PreviewMini = styled.span`
  font-size: 11px;
  opacity: 0.9;
`;

export const PreviewTitle = styled.span`
  font-size: 18px;
  font-weight: 800;
  line-height: 1.2;
`;

export const PreviewSubtitle = styled.span`
  font-size: 12px;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.9);
`;

export const PreviewFields = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
`;

export const PreviewField = styled.div`
  border: 1px solid #dbe4f0;
  border-radius: 14px;
  padding: 12px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 6px;
  grid-column: ${(props) => (props.$full ? "1 / -1" : "auto")};
`;

export const PreviewFieldLabel = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: #334155;
`;

export const PreviewFieldMeta = styled.span`
  font-size: 11px;
  line-height: 1.45;
  color: #64748b;
`;

export const PreviewResult = styled.div`
  border: 1px solid #dbe4f0;
  border-radius: 16px;
  background: #ffffff;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  strong {
    font-size: 14px;
    color: #0f172a;
  }

  small {
    font-size: 11px;
    line-height: 1.45;
    color: #64748b;
  }
`;

export const PreviewMainValue = styled.div`
  font-size: 24px;
  font-weight: 800;
  color: ${(props) => props.$color || "#0f172a"};
`;

export const PreviewSecondary = styled.div`
  border: 1px solid #dbe4f0;
  border-radius: 12px;
  background: #f8fafc;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FooterBar = styled.div`
  border-top: 1px solid #e2e8f0;
  padding: 14px 20px 16px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

export const FooterGroup = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
`;

export const AdvancedStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const CatalogLayout = styled.div`
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  gap: 14px;
`;

export const CatalogCard = styled.div`
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: #ffffff;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const CatalogItem = styled.button`
  border: 1px solid ${(props) => (props.$active ? "#8db4ff" : "#d6dee9")};
  background: ${(props) => (props.$active ? "#eff6ff" : "#ffffff")};
  border-radius: 12px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
  cursor: pointer;
`;
